<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'DuplicateManually',
  props: {
    requestId: {
      type: [String, Number],
      default: function() {
        return {}
      },
    },
    mode: {
      type: [String, Number],
      default: function() {
        return {}
      },
    },
  },
  data() {
    return {
      options: [],
      search: null,
      requestToDp: null,
      requestFromDp: null,
      loadingDataDpM: false,
      module: this.mode,
      url: {
        duplicateContract: 'contracts/duplicate',
        onSearch:
          this.mode === 'FCL'
            ? 'requests/searchSelect'
            : 'requestsLCL/searchSelect',
      },
      cmpFileResult: [
        {
          sheets: null,
          mean: null,
          detail: null,
          non_sheets: [],
          request_id: null,
          company_user: null,
        },
      ],
      cmpfiles: {
        detailBool: false,
        sheets: null,
        mean: 0,
        detail: null,
        non_sheets: [],
        request_id: null,
        company_user: null,
      },
    }
  },
  created() {
    this.requestToDp = this.requestId
  },
  methods: {
    onSearch(search, loading) {
      loading(true)
      axiosGetPost('post', this.url.onSearch, {
        rq_to_dp: this.requestToDp,
        rq_from_dp: search,
        request: true,
      }).then((data) => {
        if (data.success) {
          this.options = data.data
          loading(false)
        } else {
        }
        return data
      })
    },
    duplicateQuestion() {
      this.$swal({
        title: `Do you want to duplicate the request ${this.requestFromDp} to ${
          this.requestToDp
        }?`,
        text:
          'The process will duplicate the contract information by manual execution',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.loadingDataDpM = true
          axiosGetPost(
            'post',
            `${this.url.duplicateContract}/${this.requestFromDp}/${
              this.requestToDp
            }`,
            { module: this.module }
          ).then((response) => {
            this.loadingDataDpM = false
            this.$emit(
              'ev_update_fields',
              this.requestToDp,
              response.status,
              response.usernameLoad,
              response.locked_options
            )
            this.$swal('OK')
            return response
          })
        } else {
          this.$swal('Canceled')
        }
      })
    },
    cmpfileQuestion() {
      if (this.requestFromDp === null) {
        this.cleanShowDetail()
        this.clean()
        return
      }
      this.cleanShowDetail()
      this.loadingDataDpM = true
      axiosGetPost('post', this.url.onSearch, {
        rq_to_dp: this.requestToDp,
        rq_from_dp: this.requestFromDp,
        cmpFile: true,
      }).then((data) => {
        if (data.success) {
          this.cmpFileResult = data.data
          this.loadingDataDpM = false
          this.$emit('closeModal')
        }
        return data
      })
    },
    showDetail(detail, non_sheets, id) {
      this.cleanShowDetail()
      this.cmpfiles.detailText = detail
      this.cmpfiles.detailId = id
      this.cmpfiles.non_sheets = non_sheets
      this.cmpfiles.detailBool = true
    },
    cleanShowDetail() {
      this.cmpfiles.detailBool = false
      this.cmpfiles.detailText = null
      this.cmpfiles.detailId = null
      this.cmpfiles.non_sheets = []
    },
    clean() {
      this.cmpFileResult = [
        {
          sheets: null,
          mean: null,
          detail: null,
          non_sheets: [],
          request_id: null,
          company_user: null,
        },
      ]
      this.cleanShowDetail()
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingDataDpM"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group row">
        <div class="col-md-6">
          <h4 class="header-title mt-0 mb-1">
            <i class="uil uil-files-landscapes"></i> Request ID: From
            <span style="color: green">{{ requestFromDp }} </span> | To
            {{ requestToDp }}
          </h4>
        </div>
      </div>
      <hr />
      <div class="form-group row">
        <div class="col-lg-3"></div>
        <div class="col-lg-5">
          <label for="default">Request ID</label>
          <v-select
            v-model="requestFromDp"
            label="name"
            :filterable="false"
            :reduce="(options) => options.id"
            :options="options"
            @search="onSearch"
            @input="cmpfileQuestion"
          >
            <template slot="no-options">
              Type to search...
            </template>
          </v-select>
        </div>
        <div class="col-lg-3 mt-2">
          <br />
          <b-button
            v-if="requestFromDp !== null"
            class="col-md-5 btn-sm"
            variant="outline-success"
            @click="cmpfileQuestion"
          >
            <b style="font-size: 13px"> Compare </b>
          </b-button>
        </div>
      </div>
      <hr />
      <div class="form-group row">
        <div class="col-lg-12">
          <div
            v-if="cmpFileResult[0].request_id !== null"
            class="table-responsive"
          >
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th scope="col">Request ID</th>
                  <th scope="col">Company User</th>
                  <th scope="col">Mean</th>
                  <th scope="col">Sheets</th>
                  <th scope="col">Detail</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, r) in cmpFileResult" :key="r">
                  <th scope="row">{{ row.request_id }}</th>
                  <td>{{ row.company_user }}</td>
                  <td>{{ row.mean }}%</td>
                  <td>{{ row.sheets }}</td>
                  <td>
                    <b-button
                      class="col-md-5 btn-sm"
                      variant="outline-info"
                      @click="
                        showDetail(row.detail, row.non_sheets, row.request_id)
                      "
                    >
                      <b style="font-size: 13px">Detail</b>
                    </b-button>
                    &nbsp;
                    <b-button
                      class="col-md-5 btn-sm"
                      variant="outline-success"
                      @click="duplicateQuestion"
                    >
                      <b style="font-size: 13px"> Duplicate </b>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <div class="col-lg-12">
          <div v-if="cmpfiles.detailBool">
            <h4 class="header-title mt-0 mb-1"
              >Detail:
              {{ cmpfiles.detailText + ' / Request: ' + cmpfiles.detailId }}</h4
            >
            <br />
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Sheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, r) in cmpfiles.non_sheets" :key="r">
                    <th scope="row">{{ r + 1 }}</th>
                    <td>{{ row }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
